export const isMandatoryMessage = 'Campo obrigatório';
